/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * DatePicker body for date selection
 * The date can be selected by day, month, quarter, year
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import { Fragment } from 'react';

import { EDatePickerPeriodType, IDatePickerBodyProps } from '../../types/datePickerTypes';
import DatePickerBodyByDay from './DatePickerBodyByDay';

const DatePickerBody = (props: IDatePickerBodyProps) => {

    const {
        periodType,
    } = props

    return (
        {
            [EDatePickerPeriodType.DAY]: <DatePickerBodyByDay {...props} />,
            [EDatePickerPeriodType.MONTH]: <Fragment/>,
            [EDatePickerPeriodType.QUARTER]: <Fragment/>,
            [EDatePickerPeriodType.YEAR]: <Fragment/>,
        }[periodType]
    );
};

export default DatePickerBody;
